import { render, staticRenderFns } from "./busLegend.vue?vue&type=template&id=aadd5db4&scoped=true&"
import script from "./busLegend.vue?vue&type=script&lang=js&"
export * from "./busLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadd5db4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VChip,VItemGroup})
